import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-button"
}
const _hoisted_4 = {
  key: 1,
  class: "lang-select col-md-3"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 0,
  class: "menu-container blur-background"
}
const _hoisted_7 = { class: "menu" }
const _hoisted_8 = { class: "menu-title" }
const _hoisted_9 = { class: "menu-item" }
const _hoisted_10 = { class: "menu-subtitle" }
const _hoisted_11 = { class: "navigation" }
const _hoisted_12 = { class: "menu-item" }
const _hoisted_13 = { class: "menu-subtitle" }
const _hoisted_14 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.showFullHeader)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('search')), 1)
              ]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createTextVNode(" | ", -1)),
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('about')), 1)
              ]),
              _: 1
            }),
            _cache[8] || (_cache[8] = _createTextVNode(" | ", -1)),
            _createVNode(_component_router_link, { to: "/map" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('map')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "app-title col-md-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleSideMenu()))
      }, [
        (!$setup.showFullHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "fas fa-bars" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('title')), 1)
      ]),
      ($setup.showFullHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('language')) + ": ", 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (lang) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: lang,
                  value: lang
                }, _toDisplayString(_ctx.$t(lang)), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.$i18n.locale]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.showMenu)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "btn btn-default close-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleSideMenu()))
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('menuTitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('menuNavigation')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: "/",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleSideMenu()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('search')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/about",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleSideMenu()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('about')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/map",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleSideMenu()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('map')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('menuLanguage')) + ":", 1)
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
                class: "input-field"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (lang) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: lang,
                    value: lang
                  }, _toDisplayString(_ctx.$t(lang)), 9, _hoisted_14))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.$i18n.locale]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}